// extracted by mini-css-extract-plugin
export default {"statsGrid":"YoutubeSearchStats_statsGrid__ryscm"};